import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'ALQParent',
    label: 'ALQParent',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
